import { render, staticRenderFns } from "./Percentile.vue?vue&type=template&id=b905e88c&scoped=true"
import script from "./Percentile.vue?vue&type=script&lang=js"
export * from "./Percentile.vue?vue&type=script&lang=js"
import style0 from "./Percentile.vue?vue&type=style&index=0&id=b905e88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b905e88c",
  null
  
)

export default component.exports